// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9c7a654e","455":"3079b9bc"}[chunkId] + ".chunk.js";
};